'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _blocks = require('../../blocks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar(props) {
    _classCallCheck(this, Avatar);

    var _this = _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));

    _this.getInitials = function () {
      var _this$props = _this.props,
          name = _this$props.name,
          isCompany = _this$props.isCompany;


      var parts = name.trim().split(/\s+/).map(function (w) {
        return w.replace(/[^\w\s]/gi, '');
      }).filter(function (w) {
        return !!w;
      });

      var words = isCompany ? [parts[0], parts[1]] : [parts.shift(), parts.pop()];

      return words.filter(Boolean).map(function (n) {
        return n[0];
      }).join('');
    };

    _this.handleGravatarFetchFailed = function () {
      _this.setState({ isGravatarAvailable: false });
    };

    _this.renderContent = function (mainModifiers) {
      var _this$props2 = _this.props,
          email = _this$props2.email,
          name = _this$props2.name,
          isCompany = _this$props2.isCompany;


      switch (true) {
        case _this.state.isGravatarAvailable:
          return _react2.default.createElement(_blocks.Avatar.Image, {
            email: email,
            onError: _this.handleGravatarFetchFailed,
            small: (0, _lodash.includes)(mainModifiers, 'small')
          });
        case !!name.trim().length:
          return _react2.default.createElement(
            _blocks.Avatar.Initials,
            { modifiers: mainModifiers },
            _this.getInitials()
          );
        default:
          return _react2.default.createElement(_blocks.Avatar.Icon, {
            modifiers: mainModifiers,
            name: isCompany ? 'building' : 'user'
          });
      }
    };

    _this.renderStatus = function (statusModifiers) {
      var status = _this.props.status;

      if (status) {
        return status;
      }

      return _react2.default.createElement(_blocks.Avatar.Status, { modifiers: statusModifiers });
    };

    _this.state = {
      isGravatarAvailable: false
    };
    return _this;
  }

  _createClass(Avatar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.email) {
        this.setState({
          isGravatarAvailable: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.email !== nextProps.email) {
        this.setState({
          isGravatarAvailable: true // Try to load/show gravatar when email changes
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var statusModifiers = [];
      var mainModifiers = [];
      var modifierKeys = Object.keys(_blocks.Avatar.Status.modifiers);
      this.props.modifiers.forEach(function (modifier) {
        if ((0, _lodash.includes)(modifierKeys, modifier)) {
          statusModifiers.push(modifier);
        } else {
          mainModifiers.push(modifier);
        }
      });

      return _react2.default.createElement(
        _blocks.Avatar,
        { modifiers: mainModifiers },
        this.renderContent(mainModifiers),
        this.renderStatus(statusModifiers)
      );
    }
  }]);

  return Avatar;
}(_react.Component);

Avatar.propTypes = {
  email: _propTypes2.default.string,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  name: _propTypes2.default.string,
  isCompany: _propTypes2.default.bool,
  status: _propTypes2.default.node
};
Avatar.defaultProps = {
  email: '',
  modifiers: [],
  name: '',
  isCompany: false,
  status: null
};


Avatar.modifiers = _extends({}, _blocks.Avatar.modifiers, _blocks.Avatar.Status.modifiers);

exports.default = Avatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Avatar/index.js
// module id = 723
// module chunks = 2